import { HistoryMessageSegment } from "types/historyMessageTypes";
import { HistorySegmentType } from "Config/Enum/historySegmentType";
import { HistoryActionType } from "types/historyActionType";
import { IncidentActionReason } from "Config/Enum/incidentActionReasonsEnum";

/**
 * Builds formatted message for ACTION COMPLETE history type
 * Creates segments with bold formatting for key elements
 *
 * Message format:
 * - "The Action 'name' was completed by the 'target'. The reason for Completion was - 'completionReason'."
 */
export class CompleteActionMessageBuilder {
  static build(action: HistoryActionType): HistoryMessageSegment[] {
    const { name, target, completionReason } = action;

    // Map completion reason enum to display text
    const completionReasonText = this.getCompletionReasonText(completionReason);

    return [
      { type: HistorySegmentType.TEXT, content: "The Action " },
      { type: HistorySegmentType.BOLD, content: name },
      { type: HistorySegmentType.TEXT, content: " was completed by the " },
      { type: HistorySegmentType.BOLD, content: "Operator" },
      { type: HistorySegmentType.TEXT, content: ". " },
      { type: HistorySegmentType.LINEBREAK },
      { type: HistorySegmentType.LINEBREAK },
      { type: HistorySegmentType.TEXT, content: "The reason for completion was: " },
      { type: HistorySegmentType.BOLD, content: completionReasonText },
      { type: HistorySegmentType.TEXT, content: "." },
    ];
  }

  private static getCompletionReasonText(reason: IncidentActionReason): string {
    const reasonMap: Record<IncidentActionReason, string> = {
      [IncidentActionReason.RESOLVED]: "Issue Resolved",
      [IncidentActionReason.NOTREQUIRED]: "No Action Required",
      [IncidentActionReason.SUPERSEDED]: "Reassigned / Superseded",
    };

    return reasonMap[reason] || reason;
  }
}
